import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'apex-web/lib/components/common/Modal/Modal';
import APInput from 'apex-web/lib/components/common/APInput';
import APButton from 'apex-web/lib/components/common/APButton';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';

const affiliateModalClasses = getBEMClasses('affiliate-modal');

const alphanumericCheck = value => {
  return /^[a-zA-Z0-9]+$/.test(value)
    ? undefined
    : 'Invalid characters, use alphanumeric characters only';
};

const AffiliateModal = (props, context) => {
  const { handleSubmit, submitting } = props;

  return (
    <Modal
      isOpen={props.isOpen}
      title={context.t('Create or Edit Affiliate Tag')}
      onCancel={() => {
        props.close();
      }}
      close={props.close}
      customClass={affiliateModalClasses('ap-modal')}>
      <form onSubmit={handleSubmit} className={affiliateModalClasses('form')}>
        <div className={affiliateModalClasses('input-wraper')}>
          <APInput
            customClass={affiliateModalClasses()}
            type="text"
            name="tag"
            validate={[alphanumericCheck]}
          />
        </div>
        <div className={affiliateModalClasses('footer')}>
          <APButton type="submit" customClass={affiliateModalClasses()}>
            {submitting ? context.t('Submitting...') : context.t('Update')}
          </APButton>
        </div>
      </form>
    </Modal>
  );
};

AffiliateModal.propTypes = {
  submitting: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};

AffiliateModal.contextTypes = {
  t: PropTypes.func.isRequired
};

export default AffiliateModal;
